import { Data } from '../signup-data/DATA';
import { getGuessedDataBiden } from '../store/guessed-prefill/selectors';
import { getSignupDataValue } from '../store/signup-data/selectors';
import { trackInteraction } from './UsageTrackingMiddleware';
export const monitorChangedCompanyDomainValue = (action, state) => {
  const bidenCompanyDomain = getGuessedDataBiden(Data.CompanyDomain)(state);
  const submittedCompanyDomain = getSignupDataValue(state, Data.CompanyDomain);

  if (bidenCompanyDomain !== submittedCompanyDomain) {
    trackInteraction({
      action: `company-domain-prefilled-domain-changed`,
      properties: {
        prefilledValue: bidenCompanyDomain,
        currentValue: submittedCompanyDomain
      }
    });
  }
};
export const monitorChangedCompanyNameValue = (action, state) => {
  const bidenCompanyName = getGuessedDataBiden(Data.CompanyName)(state);
  const submittedCompanyName = getSignupDataValue(state, Data.CompanyName);

  if (bidenCompanyName !== submittedCompanyName) {
    trackInteraction({
      action: `company-domain-prefilled-companyName-changed`,
      properties: {
        prefilledValue: bidenCompanyName,
        currentValue: submittedCompanyName
      }
    });
  }
};